webpackJsonp([22],{

/***/ 88:
/***/ (function(module, exports, __webpack_require__) {

var mc = __webpack_require__(0);
mc.runVue(['Slider', 'Navigation', 'selectList']);
mc.runComponents(['rating']);
mc.runFooter();

/***/ })

},[88]);


// WEBPACK FOOTER //
// bundles/contact.bundle.js